import { gql } from '@apollo/client';
import { AnnualUserInfo, User } from 'types';

export const CREATE_USER_MUTATION = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      _id
    }
  }
`;

export type CreateUserResponse = {
  createUser: User;
};

export type CreateUserVariables = {
  input: {
    empId: string;
    name: string;
    email: string;
    hod?: string;
    role?: string;
    designation?: string;
    department?: string;
  };
};

export const UPDATE_USER_MUTATION = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      _id
    }
  }
`;

export type UpdateUserResponse = {
  updateUser: User;
};

export type UpdateUserVariables = {
  input: {
    hod?: string;
    role?: string;
    designation?: string;
    department?: string;
  };
};

export const REMOVE_EMPLOYEE_MUTATION = gql`
  mutation RemoveEmployee($user: ID!, $reasignee: ID) {
    removeEmployee(user: $user, reasignee: $reasignee)
  }
`;

export type RemoveEmployeeResponse = {
  removeEmployee: boolean;
};

export type RemoveEmployeeVariables = {
  user: string;
  reasignee: string;
};

export const MELT_USERS = gql`
  mutation MeltUsers($year: Int!, $period: Int!) {
    meltUsers(year: $year, period: $period) {
      _id
    }
  }
`;

export type MeltUsersVariables = {
  year: number;
  period: number;
};

export type MeltUsersResponse = {
  meltUsers: AnnualUserInfo[];
};
